import { idfServiceIds, ezsServiceIds } from "../config/UserServicesList";
import { useAreServicesActive } from "./CommonServices";

export const getServiceKey = (service: string) => {
    let serviceKey = "";
    switch (service) {
        case "single-bureau-score":
            serviceKey = "TransUnionCreditScore";
            break;
        case "three-bureau-score":
            serviceKey = "ThreeBureauCreditScore";
            break;
        case "single-bureau-report":
            serviceKey = "TransUnionCreditReport";
            break;
        case "three-bureau-report":
            serviceKey = "ThreeBureauCreditReport";
            break;
        case "single-bureau-score-monitoring":
        case "three-bureau-score-monitoring":
            serviceKey = "CreditScoreMonitoring";
            break;
        case "single-bureau-score-simulator":
            serviceKey = "TransUnionCreditScore";
            break;
        case "order-credit-report":
            serviceKey = "OrderCreditReport";
            break;
        case "three-bureau-score-simulator":
            serviceKey = "ThreeBureauCreditScore";
            break;
        default:
            return "";
    }
    return serviceKey;
};
export const getScoreStatus = (score: number) => {
    if (score < 720 && score >= 658) {
        return "status-average";
    } else if (score < 658) {
        return "status-bad";
    } else {
        return "status-good";
    }
};

export const getScoreRating = (score: number, tLang: any) => {
    let status = "";
    if (score <= 600) {
        status = tLang("credit.creditScore.scoreRating.veryPoor"); 
    } else if (601 <= score && score <= 657) {
        status = tLang("credit.creditScore.scoreRating.poor");
    } else if (658 <= score && score <= 719) {
        status = tLang("credit.creditScore.scoreRating.fair");
    } else if (720 <= score && score <= 780) {
        status = tLang("credit.creditScore.scoreRating.good");
    } else if (781 <= score) {
        status = tLang("credit.creditScore.scoreRating.excellent");
    }

    return status;
};

export const getScoreTrackerStatus = (score: number) => {
    if (score < 720 && score >= 658) {
        return "Medium Risk";
    } else if (score < 658) {
        return "High Rish";
    } else {
        return "Low Risk";
    }
};

export const formatCurrency = (s: number) => {
    if(s){
        const currency = s.toLocaleString("en", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); // "1,234.57"
    
        return "$" + currency;
    }
    return;
};

export const stripPhone = (s: any) => {
    return ("" + s).replace(/\D/g, "");
};

export const formatPhone = (s: any) => {
    var s2 = stripPhone(s);
    if ("undefined" !== typeof s2) {
        //CA or US matches for previously added phone numbers
        var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
        return !m ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
    }
};
export const useBureauPermission = () => {
    const singleBurauPermission: boolean = useAreServicesActive([idfServiceIds.transUnionCreditMonitoring]);
    const isIDFSingleBurauReportPermission: boolean = useAreServicesActive([idfServiceIds.transUnionCreditReport]);
    const isIDFThreeBureauReportPermission: boolean = useAreServicesActive([idfServiceIds.threeBureauCreditReports]);
    const threeBureauPermission: boolean = useAreServicesActive([idfServiceIds.threeBureauCreditScores]);
    const isEZSUserCreditPermission: boolean = useAreServicesActive([ezsServiceIds.threeBureauCreditMonitoring]);
    var bureauName = "no-permission";
    if (isIDFSingleBurauReportPermission) {
        bureauName = "single-bureau-report";
    } else if (isIDFThreeBureauReportPermission) {
        bureauName = "three-bureau-report";
    } else if (threeBureauPermission) {
        bureauName = "three-bureau-score";
    } else if (singleBurauPermission) {
        bureauName = "single-bureau-score";
    } else if (isEZSUserCreditPermission) {
        bureauName = "three-bureau-score";
    } else {
        //TODO: need to remove this line after getting confirmation
        bureauName = "three-bureau-score";
    }
    return bureauName;
};
export const useBureauPermissionCreditReport = () => {
    const singleBureauReport: boolean = useAreServicesActive([idfServiceIds.transUnionCreditReport]);
    const threeBureauReport: boolean = useAreServicesActive([idfServiceIds.threeBureauCreditReports]);
    var bureauName = "no-permission";
    if (threeBureauReport) {
        bureauName = "three-bureau-report";
    } else if (singleBureauReport) {
        bureauName = "single-bureau-report";
    } else {
        //TODO: need to remove this line after getting confirmation
        bureauName = "three-bureau-report";
    }
    return bureauName;
};

export const fetchCreditData = (creditData: any, type?: string) => {
    const isIDFUser = creditData && creditData.length > 0 && creditData[0].IsIDFUser ? true : false;
    const defaultScores = creditData && creditData.filter((report: any) => report["score-service-code"] && report["score-service-code"].includes("SCORE"));
    const defaultReports = creditData && creditData.filter((report: any) => report["service-code"] && report["service-code"].includes("CRD"));
    const scoreOnlyData =
        creditData && creditData.filter((report: any) => report["score-service-code"] && !report["score-service-code"].includes("SVCLVL-TU-CRDRPT"));
    const oneTimeReports = creditData && creditData.filter((report: any) => report["service-code"] && report["service-code"].includes("SVCLVL-TU-CRDRPT"));
    const oneTimeReportsWithScore = oneTimeReports && oneTimeReports.filter((report: any) => report["service-code"] && report["service-code"].includes("SCORE"));
    if (creditData && creditData.length > 0 && isIDFUser) {
        return creditData[0];
    } else {
        if (type === "score") {
            if (scoreOnlyData && scoreOnlyData.length > 0) {
                return scoreOnlyData[0];
            } else if (defaultScores && defaultScores.length > 0) {
                return defaultScores[0];
            } else if (oneTimeReportsWithScore && oneTimeReportsWithScore.length > 0) {
                return oneTimeReportsWithScore[0];
            }
            return null;
        } else {
            if (defaultReports && defaultReports.length > 0) {
                return defaultReports[0];
            } else if (oneTimeReports && oneTimeReports.length > 0) {
                return oneTimeReports[0];
            }
            return null;
        }
    }
};
